
import { Options, Vue } from "vue-class-component";
export default class CategoryMain extends Vue {
}
